<template>
	<section class="promotions background-light bg-flip main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
			<div v-parse-links v-html="content" />
		</div>
		<div class="row promotions-row flex-row slide-row">
			<nuxt-link
				v-for="room in items.slice(0, 4)"
				:key="room.ID"
				:to="localePath(`/${room.filename}`)"
				class="slick-item"
			>
				<div class="slick-slide-content">
					<h3>{{ room.header }}</h3>
					<span>
						{{ room.button }}
						<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
					</span>
				</div>
				<picture>
					<source
						v-if="room.imageOverviewPortraitWebp"
						:srcset="room.imageOverviewPortraitWebp"
						type="image/webp"
					/>
					<source :srcset="room.imageOverviewPortrait" />
					<img loading="lazy" :src="room.imageOverviewPortrait" :alt="room.imageOverviewPortraitAlt" />
				</picture>
			</nuxt-link>
		</div>
		<picture class="intro-bg">
			<source srcset="~/assets/images/promotions-section-bg-image-flipped.webp" type="image/webp" />
			<source srcset="~/assets/images/promotions-section-bg-image-flipped.png" />
			<img
				src="~/assets/images/promotions-section-bg-image-flipped.png"
				alt="Breathe Boutique Hotel Leiden"
				loading="lazy"
			/>
		</picture>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.background-light {
	position: relative;
	background: #f1ebe1 !important;

	.row {
		position: relative;
		z-index: 2;
	}

	.intro-bg {
		object-fit: cover;
		position: absolute;
		inset: 0;
		z-index: 1;

		img {
			width: 100%;
			height: 100% !important;
			object-fit: cover;
		}
	}
}

.contentblocks {
	background: $contentblock-background-color;
}

.row-header {
	max-width: 980px;
}
</style>
